module.exports = __webpack_public_path__ + "static/media/8.f0973691.jpg";